import { render } from "./coupon.vue?vue&type=template&id=0d09bed2&ts=true"
import script from "./coupon.vue?vue&type=script&lang=ts"
export * from "./coupon.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__